<template>
  <div class="technical-details">
    <div class="flex flex-col lg:flex-row lg:flex-wrap mb-8 lg:mb-10">
      <TechnicalDetail
        v-for="(detail, index) in technicalDetails"
        :key="index"
        :label="detail.key"
        :values="detail.values"
      />
    </div>
  </div>
</template>
<script lang="ts">

import type { ProductDetail } from '~~/types/product/attribute/ProductDetail';

export default defineComponent({
  name: 'TechnicalDetails',

  setup() {

    const route = useRoute();
    const slug = computed(() => route.params.slug);

    const { masterProductLocalisedAttributes: attributesLocalized } = useProductExtended(slug.value);

    const technicalDetails = computed<ProductDetail[]>(() => attributesLocalized.value?.techdetails || []);

    return {
      technicalDetails,
    };
  
  },
});

</script>
